import { render, staticRenderFns } from "./PdfSigns.vue?vue&type=template&id=877b08c6"
import script from "./PdfSigns.vue?vue&type=script&lang=js"
export * from "./PdfSigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports